import React from "react";

export default function ThemeDemo() {
  return (
    <div className="container-fluid py-4">
      <h2 className="text-primary mb-4">Theme Demo Page</h2>

      {/* Cards */}
      <div className="row">
        <div className="col-md-3 mb-3">
          <div className="card shadow-sm">
            <div className="card-body">
              <h5 className="text-primary">Users</h5>
              <h2>250</h2>
            </div>
          </div>
        </div>

        <div className="col-md-3 mb-3">
          <div className="card shadow-sm">
            <div className="card-body">
              <h5 className="text-success">Services</h5>
              <h2>18</h2>
            </div>
          </div>
        </div>

        <div className="col-md-3 mb-3">
          <div className="card shadow-sm">
            <div className="card-body">
              <h5 className="text-danger">Pending</h5>
              <h2>45</h2>
            </div>
          </div>
        </div>

        <div className="col-md-3 mb-3">
          <div className="card shadow-sm">
            <div className="card-body">
              <h5 className="text-warning">Completed</h5>
              <h2>520</h2>
            </div>
          </div>
        </div>
      </div>

      {/* Buttons */}

      <div className="card mt-3">
        <div className="card-body">
          <h4 className="mb-3">Buttons</h4>

          <button className="btn btn-primary me-2">Primary</button>
          <button className="btn btn-success me-2">Success</button>
          <button className="btn btn-danger me-2">Danger</button>
          <button className="btn btn-warning me-2">Warning</button>
          <button className="btn btn-info me-2">Info</button>
        </div>
      </div>

      {/* Alerts */}

      <div className="card mt-3">
        <div className="card-body">
          <div className="alert alert-primary">Primary Alert</div>

          <div className="alert alert-success">Success Alert</div>

          <div className="alert alert-danger">Danger Alert</div>
        </div>
      </div>

      {/* Form */}

      <div className="card mt-3">
        <div className="card-body">
          <h4>Form</h4>

          <input className="form-control mb-3" placeholder="Enter Name" />

          <select className="form-select mb-3">
            <option>Option 1</option>
            <option>Option 2</option>
          </select>

          <button className="btn btn-primary">Save</button>
        </div>
      </div>

      {/* Table */}

      <div className="card mt-3">
        <div className="card-body">
          <h4>Table</h4>

          <table className="table table-bordered">
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Status</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>1</td>
                <td>Dheeraj</td>
                <td>
                  <span className="badge bg-success">Active</span>
                </td>
              </tr>

              <tr>
                <td>2</td>
                <td>Admin</td>
                <td>
                  <span className="badge bg-danger">Inactive</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Progress */}

      <div className="card mt-3">
        <div className="card-body">
          <h4>Progress</h4>

          <div className="progress">
            <div className="progress-bar bg-primary" style={{ width: "70%" }}>
              70%
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
